import Configurator from "./configurator.js";
import Executor from "./executor.js";
import Corrector from "./corrector.js";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import description from "./description.js";

export default {
  title: "Orthographe (dictée)",
  icon: SpellcheckIcon,
  description,
  Configurator,
  Executor,
  Corrector,
};
